// @flow
import React from "react";
import cancel_address_input from '../../Assets/commonImages/cancel_address_input.svg';

type OwnProps = {|
    onCrossClick: () => mixed,
|}

const CrossCancel = (props: OwnProps) => {
    return (
        <img src={cancel_address_input}
             onClick={props.onCrossClick}
             style={{padding: `15px`}}
             alt="cross cancel"
        />
    );
};

export default CrossCancel;



// WEBPACK FOOTER //
// ./src/Components/CrossCancel/CrossCancel.js